import {useRouter} from 'next/router';
import {OWOX_PAGES, TOwoxPage} from 'modules/google-analytics/constants';

export const useGtagEventLocation = (): {eventLocation: TOwoxPage} => {
    const {pathname} = useRouter();

    let eventLocation: TOwoxPage;

    eventLocation = OWOX_PAGES[pathname as keyof typeof OWOX_PAGES];

    return {eventLocation};
};
